module.exports = __webpack_public_path__ + "static/media/CTLA_2-216w.0c654818.jpg";